import { Skeleton } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useChannelCards } from '@entities/channel';
import { extractErrorMessage } from '@shared/api';
import { BotPage } from './BotPage';
import { StatusPill } from './chUi';
import { WidgetPage } from './WidgetPage';
import './channels.css';

/** «← Каналы / …»: страница бота (6б) или окна чата (7) — по типу канала. */
export function ChannelRoute() {
  const { id = '', channelId = '' } = useParams<{ id: string; channelId: string }>();
  const { data, isLoading, error } = useChannelCards(id);
  const c = data?.find((x) => x.id === channelId);
  const title = !c ? 'Канал' : c.platform === 'widget' ? 'Окно чата на сайте' : c.title;

  return (
    <>
      <header className="v2-topbar is-section">
        <Link to={`/assistants/${id}/channels`} className="mp-back">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
          Каналы
        </Link>
        <span style={{ color: '#D1D5DB' }}>/</span>
        <h1>{title}</h1>
        {c?.platform === 'widget' && <StatusPill status={c.status} />}
        {/* Экран 7: «Сохранить» в верхней строке — WidgetPage рисует сюда через портал. */}
        <div id="ch-head-actions" className="v2-topbar-actions" />
      </header>
      <div className="v2-content is-section">
        {isLoading && <Skeleton active paragraph={{ rows: 6 }} />}
        {error && (
          <div className="v2-card v2-card-pad">
            Не удалось загрузить канал: {extractErrorMessage(error)}
          </div>
        )}
        {data && !c && (
          <div className="v2-card v2-card-pad">
            Канал не найден — возможно, его отключили.{' '}
            <Link to={`/assistants/${id}/channels`}>Все каналы</Link>
          </div>
        )}
        {c && c.platform === 'widget' && <WidgetPage key={c.id} assistantId={id} c={c} />}
        {c && c.platform !== 'widget' && <BotPage key={c.id} assistantId={id} c={c} />}
      </div>
    </>
  );
}
